import chunk from 'lodash/chunk'

import { Chunk } from '../_types'

export function chunkItems<T>(itemsPerChunk: number, items: T[]): Chunk<T>[] {
  const slicedItemsIntoChunks: T[][] = chunk(items, itemsPerChunk)

  return slicedItemsIntoChunks.map((chunkItems, index) => ({
    id: String(index),
    items: chunkItems,
  }))
}
